import request from '../request'

export default {
  // 产品分类：列表
  getProductCategory() {
    return request({
      url: 'api/getProductCategory',
      method: 'post'
    })
  },
  // 产品：列表
  getProduct(data) {
    return request({
      url: 'api/getProduct',
      method: 'post',
      data
    })
  },
  // 产品：详情
  getProductDetail(id) {
    return request({
      url: 'api/getProductDetail',
      method: 'post',
      data: {id}
    })
  },
  // 新闻分类：列表
  getNewsCategory() {
    return request({
      url: 'api/getNewsCategory',
      method: 'post'
    })
  },
  // 新闻：列表
  getNews(data) {
    return request({
      url: 'api/getNews',
      method: 'post',
      data
    })
  },
  // 新闻：详情
  getNewsDetail(id) {
    return request({
      url: 'api/getNewsDetail',
      method: 'post',
      data: {id}
    })
  },
  // 关于：列表
  getAbout() {
    return request({
      url: 'api/getAbout',
      method: 'post'
    })
  },
  // 行业：列表
  getIndustries() {
    return request({
      url: 'api/getIndustries',
      method: 'post'
    })
  },
  // 服务：列表
  getService() {
    return request({
      url: 'api/getService',
      method: 'post'
    })
  },
  // 合作伙伴：列表
  getPartners() {
    return request({
      url: 'api/getPartners',
      method: 'post'
    })
  },
  // 获取参数
  getConfig(){
    return request({
      url: 'api/getConfig',
      method: 'post'
    })
  },
  // 获取招聘
  getRecruit(){
    return request({
      url: 'api/getRecruit',
      method: 'post'
    })
  },
  // 获取联系信息
  getContact(){
    return request({
      url: 'api/getContact',
      method: 'post'
    })
  },
  // 获取轮播
  getSliders(){
    return request({
      url: 'api/getSliders',
      method: 'post'
    })
  }
}


// WEBPACK FOOTER //
// ./src/service/api/index.js